export const valueDefaultSizes = {
  USER_CODE_MIN: 4,
  USER_CODE_MAX: 50,
  USER_NAME_MIN: 5,
  USER_NAME_MAX: 255,
  USER_PASSWORD_MIN: 5,
  USER_PASSWORD_MAX: 255,
  USER_DESCRIPTION_MAX: 1024,

  COUNTRY_LENGTH: 2,
  NAME_MIN_LENGTH: 3,
  NAME_MAX_LENGTH: 255,
  VARCHAR_MAX_LENGTH: 50,
  LONG_VARCHAR_MAX_LENGTH: 255,
  SHORT_TEXT_MAX_LENGTH: 1024,
  TEXT_MAX_LENGTH: 2048,
  OFFER_NAME_LENGTH: 100,
};

export const DEFAULT_PAGE = 0;

export const MINUTES_PER_DAY = 24 * 60;
